<div class="flex flex-col gap-2 mb-6">
  <div class="h-8 w-2/3 rounded-md overflow-hidden"><dss-libs-ui-skeleton /></div>
  <div class="h-5 w-48 rounded-md overflow-hidden"><dss-libs-ui-skeleton /></div>
</div>
<div class="flex flex-col lg:flex-row gap-6">
  <div class="flex flex-col gap-4 flex-1">
    <div class="h-48 rounded-lg overflow-hidden"><dss-libs-ui-skeleton /></div>
    <div class="h-[30rem] rounded-lg overflow-hidden"><dss-libs-ui-skeleton /></div>
  </div>
  <div class="w-full lg:w-90 flex flex-col gap-4">
    <div class="h-96 rounded-lg overflow-hidden"><dss-libs-ui-skeleton /></div>
    <div class="h-72 rounded-lg overflow-hidden"><dss-libs-ui-skeleton /></div>
  </div>
</div>
